var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}drop`,"viewBox":"0 0 40 48"}},[_c('path',{staticClass:"sign",attrs:{"d":"M40 28c0 11-9 20-20 20S0 39 0 28C0 14 20 0 20 0s20 14 20 28z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }